import { render } from "./UnitSettings.vue?vue&type=template&id=632a2719&scoped=true"
import script from "./UnitSettings.vue?vue&type=script&lang=js"
export * from "./UnitSettings.vue?vue&type=script&lang=js"

import "./UnitSettings.vue?vue&type=style&index=0&id=632a2719&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632a2719"]])

export default __exports__